
import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { CanonicalService } from 'src/app/canonical.service';


@Component({
  selector: 'app-mmt',
  templateUrl: './mmt.component.html',
  styleUrls: ['./mmt.component.css' ] // Fixed typo here
})
export class MmtComponent implements OnInit {

  constructor(private meta: Meta, private title: Title, private canonicalService: CanonicalService) {
  }

  ngOnInit(): void {
    this.title.setTitle("Exclusive MakeMyTrip Discounts with SingX – Sign Up and Save on Travel");
    this.canonicalService.updateCanonicalUrl('/makemytrip-discount');
    this.meta.updateTag({ name: 'description', content: 'Join SingX for affordable remittance services and access exclusive MakeMyTrip discounts on flights and hotels. Sign up today and start saving.' })
    this.meta.updateTag({ name: 'author', content: 'SingX' })
    this.meta.updateTag({ name: 'keywords', content: 'Instant Money Transfer Overseas, Money Transfer Overseas, International Money Transfer, remittance, Fast Money Transfer Overseas, Cheapest Way to Transfer Money Overseas, Online Money Transfer overseas, Best Money Transfer to India, International Business Payment, Money Transfer Overseas for Business.' })
  }
}